import React, { memo } from 'react';
import {
  Theme,
  ClickAwayListener,
  Popper,
  Grow,
  Paper,
  MenuList,
  MenuItem,
  ListItemIcon,
  Divider,
  PopperProps,
} from '@material-ui/core';
import clsx from 'clsx';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { Typography } from '../Typography';

const styles = (theme: Theme) => {
  return createStyles({
    popper: {
      zIndex: 1000,
    },
    root: {
      '& .MuiListItemIcon-root': {
        minWidth: 35,
        color: theme.palette.secondary.main,
      },
      '& .MuiMenuItem-root': {
        padding: '8px 20px',

        '&:hover': {
          backgroundColor: theme.palette.grey[100],
        },
      },
    },
    topDivider: {
      marginBottom: '8px',
    },
    primaryColorText: {
      background: theme.custom.primaryGradient,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 600,
    },
    bottomDivider: {
      marginTop: '8px',
    },
  });
};

export interface IMenuItemProps {
  onClick: React.MouseEventHandler<HTMLLIElement> | undefined;
  icon?:
  | boolean
  | React.ReactChild
  | React.ReactFragment
  | React.ReactPortal
  | null
  | undefined;
  label:
  | boolean
  | React.ReactChild
  | React.ReactFragment
  | React.ReactPortal
  | null
  | undefined;
  id: string;
  selected?: any;
}

export interface IDropdownProps extends WithStyles<typeof styles> {
  topChildren?: React.ReactNode;
  id: string;
  customStyles?: any;
  open: boolean;
  anchorRef: any;
  handleClose: (event: React.MouseEvent<EventTarget>) => void;
  itemList: any;
  bottomChildren?: React.ReactNode;
  placement?: PopperProps['placement'];
}

const Dropdown = ({
  classes,
  id,
  topChildren,
  customStyles,
  open,
  anchorRef,
  handleClose,
  itemList,
  bottomChildren,
  placement,
}: IDropdownProps) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorRef}
      role={undefined}
      transition
      className={classes.popper}
      placement={placement}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper className={clsx(classes.root, customStyles && customStyles)}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList
                autoFocusItem={open}
                id={id}
              // onKeyDown={handleListKeyDown}
              >
                {topChildren}
                {topChildren && <Divider className={classes.topDivider} />}
                {itemList.map((data: IMenuItemProps) => {
                  if (data != null) {
                    return (
                      <MenuItem
                        onClick={data.onClick}
                        key={data.id}
                        className={
                          data.selected ? classes.primaryColorText : undefined
                        }
                      >
                        {data.icon && <ListItemIcon>{data.icon}</ListItemIcon>}
                        <Typography variant="h6">{data.label}</Typography>
                      </MenuItem>
                    );
                  }

                  return <Divider className={classes.topDivider} />;
                })}
                {bottomChildren && (
                  <Divider className={classes.bottomDivider} />
                )}
                {bottomChildren}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default memo(withStyles(styles)(Dropdown));
